






















import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
import AsiTextField from "@/components/common/AsiTextField";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";
import {AxiosError} from "axios";
import BillUpdate from "@/models/bill/BillUpdate";
import Bill from "@/models/bill/Bill";
import CompanyAutocompleteInput from "@/components/company/CompanyAutocompleteInput.vue";

@Component({
	components: {
		AsiTextField,
		AsiDialogFormLayout,
		AsiDatePicker,
		CompanyAutocompleteInput
	}
})
export default class BillUpdateDialogBasicData extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public bill!: Bill;

	private model: BillUpdate | null = null;

	public created(): void {
		this.setBillInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setBillInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('bill', {deep: true})
	private onBillChanged(): void {
		this.setBillInternal();
	}

	private setBillInternal(): void {
		if (this.model === null) {
			this.model = new BillUpdate(this.bill);
		} else {
			this.model.setDetailModel(this.bill);
		}
	}

	private requestSave(event: Event): void {
		if (this.model === null) return;

		this.loading = true;
		this.$billService.update(this.bill.id, this.model)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
